/* eslint-disable no-unused-vars */
import { IApiResponse } from "../../models";

export enum ECurrency {
  SAR = "SAR",
}

export interface IBankDetailsResponseData {
  id: 0;
  iban: string;
  accountNumber: string;
  currency: ECurrency;
  beneficiaryName: string;
  bank: {
    id: number;
    arabicName: string;
    englishName: string;
    abbreviation: string;
    swiftCode: string;
  };
}

export interface ISupportedBankData {
  abbreviation: string;
  arabicName: string;
  englishName: string;
  id: number;
  swiftCode: string;
}

export interface IBankDetailsBody {
  iban: string;
  currency: ECurrency;
  beneficiaryName: string;
  bankId: number;
}

export interface ISupportedBankDetailsResponse extends IApiResponse {
  data: ISupportedBankData[];
}

export interface IBankDetailsResponse extends IApiResponse {
  data: IBankDetailsResponseData;
}
